<template>
  <div class="container">
    <h3>{{obj.title}}</h3>
    <div class="flex">
      <p>发布者：{{obj.org_name}}</p>
      <p>发布日期：{{timeTrans(obj.createtime)}}</p>
    </div>
    <div class="main" v-html="obj.content"></div>
  </div>
</template>
<script>
export default {
  name:'policydetail',
  data() {
    return {
      obj:{},
    }
  },
  created(){
    console.log('id:'+this.$route.query.id);
    this.$axios({
      method:'post',
      url:'/api/policy/info',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken'),
        id:this.$route.query.id,
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.obj = res.data.data;
      }else{
        this.$toast(res.data.msg);
      }
    })
  },
  updated() {
    let img = document.querySelectorAll("img");//获取所有图片
    for (let i = 0; i < img.length; i++) {
      const element = img[i];
      //添加样式
      element.style.width = "100%";
      element.style.margin = "10px auto";
      element.style.display = 'block';
    }
  },
}
</script>
<style scoped>
.container{
  padding: 20px;
}
h3{
  text-align: center;
  margin: 0 auto;
}
.main{
  margin-top: 20px;
  line-height: 2em;
}
.main img{
  width: 100%;
  margin: 10px 0;
}
.flex{
  margin: 10px 0;
  font-size: 12px;
}
.container /deep/ video{
  width: 100%;
  margin: 10px 0;
  display: block;
}
.container /deep/ iframe{
  width: 100% !important;
  height: 55vw !important;
}
</style>


// WEBPACK FOOTER //
// src/components/policydetail.vue